import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { articles, categories } from "@/mocks/news";

export default function CategorySection() {
  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="label-font text-xs uppercase tracking-[0.24em] text-primary-600">
              Columns
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              内容栏目
            </h2>
            <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
              五个栏目分别承担不同的信息职责：有的负责记录动作，有的负责梳理顺序，有的负责解释原因。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, index) => {
            const count = articles.filter((item) => item.categorySlug === cat.slug).length;
            const isWide = index === 0;
            return (
              <Reveal
                key={cat.slug}
                delay={Math.min(index, 4) * 60}
                className={isWide ? "md:col-span-2" : ""}
              >
                <Link
                  to={`/category/${cat.slug}`}
                  className="card-lift group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${cat.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {cat.name}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {cat.intro}
                  </p>
                  <span className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5 text-xs text-foreground-500">
                    <span>已收录 {count} 组条目</span>
                    <span className="flex items-center gap-1 text-primary-600">
                      进入栏目
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                    </span>
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}